import { render, staticRenderFns } from "./PayslipDesignPreview.vue?vue&type=template&id=669c3d40&scoped=true"
import script from "./PayslipDesignPreview.vue?vue&type=script&lang=js"
export * from "./PayslipDesignPreview.vue?vue&type=script&lang=js"
import style0 from "./PayslipDesignPreview.vue?vue&type=style&index=0&id=669c3d40&prod&scoped=true&lang=css"
import style1 from "./PayslipDesignPreview.vue?vue&type=style&index=1&id=669c3d40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669c3d40",
  null
  
)

export default component.exports